import { IMapRender } from "../../definitions/map/IMapRender";
import { IPage } from "../../definitions/page/IPage";

export abstract class BaseMapPageContent implements IPage {
  private _mapRender: IMapRender | null = null;

  abstract getMapRender(): IMapRender;

  render(
    pageContent: HTMLDivElement,
    _secondSidebarWrapper: HTMLDivElement,
  ): void {
    this._mapRender = this.getMapRender();
    pageContent.innerHTML = this._mapRender.render();
    this._mapRender.connect();
  }

  protected _disposed: boolean = false;

  dispose(): void {
    this._mapRender?.dispose();
    this._disposed = true;
  }
}
